import { animate, inView, stagger } from "motion";

const BALLOT_MARKS_START_EVENT = "ballot-marks:start";
const HIDDEN_OPACITY_CLASS = "motion-safe:opacity-0";
const ANIMATION_EASE = [0.22, 0.61, 0.36, 1];
const HEADLINE_ANIMATION = { scale: [1.5, 1], opacity: [0, 1] };
const HEADLINE_TRANSITION = { duration: 0.6, ease: ANIMATION_EASE };
const CONTENT_OVERLAP = "-0.18";
const CONTENT_TRANSITION = { duration: 0.5, ease: ANIMATION_EASE };
const MISSION_STATEMENT_STAGGER = 0.08;

function prepareSvgHeadlineParts(parts) {
  parts.forEach((part) => {
    part.classList.remove(HIDDEN_OPACITY_CLASS);
    part.setAttribute("opacity", "0");
    part.style.transformBox = "fill-box";
    part.style.transformOrigin = "50% 50%";
  });
}

function prepareMissionStatementParts(missionStatement) {
  if (!missionStatement) {
    return [];
  }

  const children = Array.from(missionStatement.children);

  missionStatement.classList.remove(HIDDEN_OPACITY_CLASS);

  if (!children.length) {
    missionStatement.style.opacity = "0";
    return [missionStatement];
  }

  children.forEach((child) => {
    child.style.opacity = "0";
  });

  return children;
}

function startBallotMarks() {
  window.dispatchEvent(new Event(BALLOT_MARKS_START_EVENT));
}

function init() {
  const pageHeader = document.querySelector("[data-page-header]");

  if (!pageHeader) {
    return;
  }

  if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;

  const voices = Array.from(document.querySelectorAll("[data-home-headline-voices]"));
  const choices = Array.from(document.querySelectorAll("[data-home-headline-choices]"));
  const missionStatement = document.querySelector("[data-header-mission-statement]");
  const leadIn = document.querySelector("[data-header-lead-in]");
  const actions = document.querySelector("[data-header-actions]");
  let played = false;

  inView(
    pageHeader,
    async () => {
      if (played) return;
      played = true;

      prepareSvgHeadlineParts([...voices, ...choices]);

      if (voices.length) {
        await animate(voices, HEADLINE_ANIMATION, HEADLINE_TRANSITION).finished;
      }

      if (choices.length) {
        await animate(choices, HEADLINE_ANIMATION, HEADLINE_TRANSITION).finished;
      }

      const missionStatementParts = prepareMissionStatementParts(missionStatement);
      const contentSequence = [];

      if (missionStatementParts.length) {
        contentSequence.push([
          missionStatementParts,
          { y: [20, 0], opacity: [0, 1] },
          { ...CONTENT_TRANSITION, delay: stagger(MISSION_STATEMENT_STAGGER) },
        ]);
      }

      [leadIn, actions].filter(Boolean).forEach((part) => {
        contentSequence.push([
          part,
          { y: [20, 0], opacity: [0, 1] },
          contentSequence.length === 0 ? CONTENT_TRANSITION : { ...CONTENT_TRANSITION, at: CONTENT_OVERLAP },
        ]);
      });

      if (contentSequence.length) {
        await animate(contentSequence).finished;
      }

      startBallotMarks();
    },
    { margin: "0px 0px -10% 0px" },
  );
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", init);
} else {
  init();
}
